import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import EmployeesEditForm from './../../elements/cdms/employees';
import Loading from "../../elements/loading";

class EmployeesEdit extends Component {
	render (){
		const {cdms} = this.props;
		return (
			cdms.isFetching ? <Loading/>:<EmployeesEditForm {...this.props}/>
		);
	}

	componentWillMount() {
		let {state} = this.props.match.params;
		this.props.cdmEmployees(state);
	}

	componentWillReceiveProps(nextprops) {
		let response = {
			role_id: undefined, title: undefined, name: undefined, last_name: undefined, slast_name: undefined, sex: undefined, curp: undefined, rfc: undefined, rfc_invoices: undefined,
			scholarship: undefined, email: undefined, email_2: undefined, telephone: undefined, telephone_2: undefined, period_start: undefined, period_end: undefined
		}
		if(nextprops.match.params.state !== this.props.match.params.state) {
			let {state} = nextprops.match.params;
			this.props.cdmEmployees(state);
		}

		if(nextprops.match.params.municipality !== this.props.match.params.municipality) {
			this.props.loadFormData('cdms.edit', {...response});
		}
	}
}

export default BaseLayout(EmployeesEdit, {
    title:"Registro personal cdm",
    subcdmnav:{
        icon: 'fa fa-user-times',
        name: 'CDM'
    },
    stateNav: true
});



// WEBPACK FOOTER //
// ./src/layouts/cdms/employees.jsx